import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let tokenGetter = null;
export const setTokenGetter = (fn) => { tokenGetter = fn; };
export const api = axios.create({ baseURL: API });
api.interceptors.request.use(async (c) => {
  if (tokenGetter) {
    const t = await tokenGetter();
    if (t) c.headers.Authorization = `Bearer ${t}`;
  }
  return c;
});
export const authToken = () => (tokenGetter ? tokenGetter() : null);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Something went wrong";
};

export const inr = (v, compact = false) => {
  const n = Number(v || 0);
  if (compact) {
    const a = Math.abs(n);
    if (a >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
    if (a >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  }
  return "₹" + n.toLocaleString("en-IN", { minimumFractionDigits: Number.isInteger(n) ? 0 : 2, maximumFractionDigits: 2 });
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};
export const fmtDT = (s) => (s ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const todayISO = () => new Date().toISOString().slice(0, 10);

export async function openFile(path, filename, download = false) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  if (download) {
    const a = document.createElement("a");
    a.href = url; a.download = filename || "file"; a.click();
  } else window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function toCSV(rows, cols) {
  const keys = cols || Object.keys(rows[0] || {});
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const body = [keys.join(","), ...rows.map((r) => keys.map((k) => esc(typeof r[k] === "object" ? JSON.stringify(r[k]) : r[k])).join(","))].join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([body], { type: "text/csv" }));
  a.download = "export.csv"; a.click();
}

export function useFetch(path, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    if (!path) { setLoading(false); return; }
    setLoading(true);
    try { setData((await api.get(path)).data); setError(null); }
    catch (e) { setError(errMsg(e)); }
    finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);
  useEffect(() => { load(); }, [load]);
  return { data, error, loading, reload: load, setData };
}
